<template>
  <div ref="appContent" class="app-body" style="padding-bottom: 80px;">
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :span="8">
          <el-form-item label="订单编号：" >
            {{purchaseInfo.orderCode}}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="采购合同编号：" >
            {{purchaseInfo.code}}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="入库时间：" prop="operateTime">
            <el-date-picker
                v-model="dataForm.operateTime"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                placeholder="选择出入库时间"
                size="mini"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收货仓库：" prop="storageId">
            <storages v-model="dataForm.storageId" size="mini" ref="storage" :ids="storageIds"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="物流公司：" prop="carriageMan">
            <dict v-model="dataForm.carriageMan" size="mini" dictName="carriage_man"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="物流号：" prop="carriageNo">
            <el-input v-model="dataForm.carriageNo" size="mini"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="备注：" prop="remark">
            <el-input
                size="mini"
                v-model="dataForm.remark"
                placeholder="备注"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="凭证照片：" prop="imgs">
        <MultipleImageUpload v-model="dataForm.imgs"></MultipleImageUpload>
      </el-form-item>
      <el-table :data="dataForm.detailList" empty-text="请选择收货仓库" border style="width: 100%"
                :summary-method="getSummaries"
                show-summary>
        <el-table-column
            type="index"
            width="50"
            label="行号"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column label="品名" prop="name" align="center">
        </el-table-column>
        <el-table-column label="颜色" prop="color" align="center">
        </el-table-column>
        <el-table-column label="规格" prop="size" align="center">
        </el-table-column>
        <el-table-column label="幅宽" prop="attr1" align="center">
        </el-table-column>
        <el-table-column label="克重" prop="attr2" align="center">
        </el-table-column>
        <el-table-column label="收货单价" prop="price">
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.price'"
                :rules="detailRule.price"
                label-width="0"
                size="mini"
                style="margin-bottom: 0;"
            >
              <el-input v-model="scope.row.price"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="收货数量"
            header-align="center"
            prop="realCount"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.realCount'"
                :rules="detailRule.count"
                label-width="0"
                size="mini"
                style="margin-bottom: 0;"
            >
              <el-input v-model="scope.row.realCount"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div class="form-foot fixed">
      <el-button @click="cancel()">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t('confirm')
        }}
      </el-button>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import MultipleImageUpload from '@/components/MultipleImageUpload'
import moment from 'moment'
import BigNumber from 'bignumber.js'

export default {
  mixins: [],
  components: { MultipleImageUpload },
  data () {
    return {
      id: '',
      dataForm: {},
      visible: false,
      loading: false,
      purchaseId: '',
      purchaseInfo: {},
      storageIds: []
    }
  },
  watch: {
    'dataForm.storageId': {
      handler: function (newVal) {
        if (!this.purchaseInfo || !this.purchaseInfo.sendList) {
          return
        }
        this.dataForm.detailList = this.purchaseInfo.sendList.filter(item => item.storageId === newVal).map(item => {
          return {
            ...item,
            name: item.productName,
            color: item.prodcutColor,
            size: item.productSize,
            attr1: item.productAttr1,
            attr2: item.productAttr2,
            realCount: item.count,
            price: 0
          }
        })
        this.dataForm.detailList.forEach(item => {
          let pd = this.purchaseInfo.detailList.find(d => d.productId === item.productId)
          if (!pd) {
            return
          }
          item.price = pd.price
        })
      }
    }
  },
  computed: {
    detailRule () {
      return {
        name: [{ required: true, message: '请填写名称', trigger: 'change' }],
        code: [{ required: true, message: '请填写品番号', trigger: 'change' }],
        count: [
          { required: true, message: '请填写数量', trigger: 'change' },
          {
            validator: function (rule, value, callback) {
              let n = parseInt(value)
              if (isNaN(n) || n === 0) {
                callback(new Error('请输入正确的数量'))
              }
              callback()
            },
            trigger: 'change',
          },
        ],
      }
    },
    dataRule () {
      return {
        receiptCode: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'change',
        }],
        operateTime: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'change',
        }],
        storageId: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'change',
        }],
      }
    }
  },
  activated () {
    this.purchaseId = this.$route.query.purchaseId
    this.reset()
    this.getPurchaseInfo()
    this.$nextTick(() => {
      if (this.$refs['dataForm']) {
        this.$refs['dataForm'].clearValidate()
      }
    })
  },
  methods: {
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index == 6) {
          let totalValue = new BigNumber(0)
          data.forEach(item => {
            let price = item['price']
            let count = item['realCount']
            if (!price || !count || isNaN(price) || isNaN(count)) {
              return
            }
            totalValue = totalValue.plus(new BigNumber(price).multipliedBy(count))
          })
          sums[index] = '总价：' + totalValue.toFixed(3)
        } else if (index == 7) {
          let totalValue = new BigNumber(0)
          data.forEach(item => {
            let count = item['realCount']
            if (!count || isNaN(count)) {
              return
            }
            totalValue = totalValue.plus(count)
          })
          sums[index] = totalValue.toFixed(3)
        }
      })
      return sums
    },
    getPurchaseInfo () {
      this.$http.get(`/purchase/${this.purchaseId}`).then(({ data: res }) => {
        this.purchaseInfo = res.data
        this.storageIds = [...new Set(res.data.sendList.map(item => item.storageId))]
        this.$nextTick(() => {
          this.$refs.storage.getDataList()
        })
      })
    },
    cancel () {
      this.$router.back()
    },
     reset () {
      this.imgArr = []
      this.dataForm = {
        id: '',
        remark: '',
        receiptCode: '',
        operateTime: moment().format('yyyy-MM-DD'),
        storageId: '',
        storageName: '',
        carriageNo: '',
        carriageMan: '',
        imgs: '',
        purchaseAgreementId: '',
        distribution: '',
        factoryId: '',
        factoryName: '',
        detailList: [],
      }
    },

    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }
            if (
                !this.dataForm.detailList ||
                this.dataForm.detailList.length === 0
            ) {
              return this.$message.error('明细不能为空')
            }
            let postForm = {
              receiptCode: this.dataForm.receiptCode,
              operateTime: this.dataForm.operateTime,
              carriageNo: this.dataForm.carriageNo,
              carriageMan: this.dataForm.carriageMan,
              purchaseAgreementId: this.dataForm.purchaseAgreementId,
              imgs: this.dataForm.imgs,
              remark: this.dataForm.remark,
              storageId: this.dataForm.storageId,
              sourceId: this.id,
              detailList: [],
            }
            this.dataForm.detailList.forEach((item) => {
              if (!item.realCount || item.realCount === 0) {
                return
              }
              postForm.detailList.push({
                id: item.id,
                count: item.realCount,
                productId: item.productId,
                remark: item.remark,
              })
            })
            if (postForm.detailList.length === 0) {
              return this.$message.error('请输入收货数量')
            }
            this.loading = true
            this.$http
                .post('/trade/purchase/check/in', postForm)
                .then(({ data: res }) => {
                  this.loading = false
                  if (res.code !== 0) {
                    return this.$message.error(res.msg)
                  }
                  this.$message({
                    message: this.$t('prompt.success'),
                    type: 'success',
                    duration: 500,
                    onClose: () => {
                      this.cancel()
                      this.$emit('refreshDataList')
                    },
                  })
                })
                .catch((e) => {
                  console.log(e)
                  this.loading = false
                })
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
  },
}
</script>

<style lang="scss" scoped>

</style>
